import { Card } from "reactstrap";
import { useState } from "react";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import { useAppSelector } from "../../../ReduxToolkit/Hooks";
import { CRUDPermissions } from "../../../Types/Common/Access";

// Cards
import EmployeePersonal from "./PersonalInformation";
import EmployeeAttchment from "./Attachment&Remarks";
import EmploymentDetails from "./EmploymentDetails";
import EmployeeDeployment from "./EmployeeDeployment";

interface EmployeeProfileProps {
  EmpNo: string;
  access: CRUDPermissions;
}

const EmployeeProfileTab: React.FC<EmployeeProfileProps> = ({
  EmpNo,
  access,
}) => {
  const [activeTab, setActiveTab] = useState("PRSN");

  const { user } = useAppSelector((state) => state.auth);

  const currentUserRoles = user?.roles?.map((role) => role.slug) || [];

  const allowedRoles = ["admin", "hr-admin"];

  const hasAdminAccess = currentUserRoles.some((role) =>
    allowedRoles.includes(role),
  );

  return (
    <>
      <Card className="left-sidebar-wrapper">
        <div className="advance-options">
          <Nav
            tabs
            className="border-tab flex-nowrap m-0"
            id="employee-profile-tabs"
          >
            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "PRSN" ? "active" : ""}`}
                onClick={() => setActiveTab("PRSN")}
                id="personal-information-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-user me-1"></i> Personal Information
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "ATCH" ? "active" : ""}`}
                onClick={() => setActiveTab("ATCH")}
                id="attachments-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-paperclip me-1"></i> Attachments & Remarks
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "EMPD" ? "active" : ""}`}
                onClick={() => setActiveTab("EMPD")}
                id="employment-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-briefcase me-1"></i> Employment Details
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "DEPT" ? "active" : ""}`}
                onClick={() => setActiveTab("DEPT")}
                id="deployments-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-map-marker me-1"></i> Deployments
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "5" ? "active" : ""}`}
                onClick={() => setActiveTab("5")}
                id="attendance-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-calendar me-1"></i> Attendance & Leaves
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "7" ? "active" : ""}`}
                onClick={() => setActiveTab("7")}
                id="payroll-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-credit-card-alt me-1"></i> Payroll &
                Benefits
              </NavLink>
            </NavItem>

            <NavItem>
              <NavLink
                className={`f-w-600 ${activeTab === "9" ? "active" : ""}`}
                onClick={() => setActiveTab("9")}
                id="performance-tab"
                style={{ fontSize: "13px" }}
              >
                <i className="fa fa-star me-1"></i> Performance
              </NavLink>
            </NavItem>
          </Nav>
        </div>
      </Card>

      <TabContent activeTab={activeTab} id="employee-profile-tabContent">
        <TabPane tabId="PRSN">
          {activeTab === "PRSN" && (
            <EmployeePersonal EmpNo={EmpNo} access={access} />
          )}
        </TabPane>

        <TabPane tabId="ATCH">
          {activeTab === "ATCH" && (
            <EmployeeAttchment EmpNo={EmpNo} access={access} />
          )}
        </TabPane>

        <TabPane tabId="EMPD">
          {activeTab === "EMPD" && (
            <EmploymentDetails
              EmpNo={EmpNo}
              isAdmin={hasAdminAccess}
              access={access}
            />
          )}
        </TabPane>

        <TabPane tabId="DEPT">
          {activeTab === "DEPT" && (
            <EmployeeDeployment
              EmpNo={EmpNo}
              isAdmin={hasAdminAccess}
              access={access}
            />
          )}
        </TabPane>

        <TabPane tabId="6">{/* Attachments */}</TabPane>

        <TabPane tabId="7">{/* Payroll & Benefits */}</TabPane>

        <TabPane tabId="9">{/* Performance */}</TabPane>
      </TabContent>
    </>
  );
};

export default EmployeeProfileTab;
